import { ActionIcon, Tooltip, useComputedColorScheme, useMantineColorScheme, type ActionIconProps } from '@mantine/core';
import { IconLanguage, IconMoon, IconSun } from '@tabler/icons-react';
import { useTranslation } from 'react-i18next';
import { setLanguage, type Lang } from '@web/i18n';

/** Light/dark toggle (persisted in `kfms.colorScheme`). */
export function ColorSchemeToggle(props: ActionIconProps) {
  const { t } = useTranslation();
  const { setColorScheme } = useMantineColorScheme();
  const computed = useComputedColorScheme('light', { getInitialValueInEffect: true });
  const next = computed === 'dark' ? 'light' : 'dark';
  const label = t(next === 'dark' ? 'common:theme.dark' : 'common:theme.light');
  return (
    <Tooltip label={label}>
      <ActionIcon variant="subtle" color="gray" aria-label={label} onClick={() => setColorScheme(next)} {...props}>
        {computed === 'dark' ? <IconSun size={20} aria-hidden /> : <IconMoon size={20} aria-hidden />}
      </ActionIcon>
    </Tooltip>
  );
}

/** Arabic ⇄ English switch; flips direction (RTL/LTR) through the providers. */
export function LanguageToggle(props: ActionIconProps) {
  const { t, i18n } = useTranslation();
  const next: Lang = i18n.language === 'ar' ? 'en' : 'ar';
  const label = t('common:language.switchTo', { lng: next });
  return (
    <Tooltip label={label}>
      <ActionIcon variant="subtle" color="gray" aria-label={label} onClick={() => void setLanguage(next)} {...props}>
        <IconLanguage size={20} aria-hidden />
      </ActionIcon>
    </Tooltip>
  );
}
